const serviceBazarNp = {
  sidebar: {
    categoriesTitle: 'सेवाको प्रकार',
    providersTitle: 'सेवा प्रदायक'
  },
  search: {
    placeholder: 'सेवा खोज्नुहोस्...'
  },
  card: {
    provider: 'सेवा प्रदायक',
    experience: 'अनुभव',
    book: 'बुक गर्नुहोस्',
    contact: 'सम्पर्क गर्नुहोस्'
  },
  empty: {
    title: 'कुनै सेवा फेला परेन',
    subtitle: 'कृपया फिल्टर वा खोजाई परिवर्तन गर्नुहोस्',
    clear: 'सबै फिल्टर हटाउनुहोस्'
  }
};

export default serviceBazarNp;


